export class TagType {
    tagTypeId: number;
    tagTypeName: string;
    tagId: number;
    tagName: string;
}
